import Enumerator from '../global/Enumerator';

export const ticketPersonalLoanPurposes = [
  'none',
  'car_purchase',
  'car_repairs',
  'debt_consolidation',
  'educational_expenses',
  'home_improvements',
  'household_furnishing',
  'medical_or_details',
  'other_vehicle_purchase',
  'small_debts',
  'travel',
  'other'
];

export class TicketPersonalLoanPurpose extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'car_purchase';
        break;
      case '2':
        correctOption = 'car_repairs';
        break;
      case '3':
        correctOption = 'debt_consolidation';
        break;
      case '4':
        correctOption = 'educational_expenses';
        break;
      case '5':
        correctOption = 'home_improvements';
        break;
      case '6':
        correctOption = 'household_furnishing';
        break;
      case '7':
        correctOption = 'medical_or_details';
        break;
      case '8':
        correctOption = 'other';
        break;
      case '9':
        correctOption = 'other_vehicle_purchase';
        break;
      case '10':
        correctOption = 'small_debts';
        break;
      case '11':
        correctOption = 'travel';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

TicketPersonalLoanPurpose.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  car_purchase: {
    get title() {
      return 'Car purchase';
    }
  },
  car_repairs: {
    get title() {
      return 'Car repairs';
    }
  },
  debt_consolidation: {
    get title() {
      return 'Debt consolidation';
    }
  },
  educational_expenses: {
    get title() {
      return 'Educational expenses';
    }
  },
  home_improvements: {
    get title() {
      return 'Home improvements';
    }
  },
  household_furnishing: {
    get title() {
      return 'Household furnishing';
    }
  },
  medical_or_details: {
    get title() {
      return 'Medical/Details';
    }
  },
  other_vehicle_purchase: {
    get title() {
      return 'Other Vehicle purchase';
    }
  },
  small_debts: {
    get title() {
      return 'Small debts';
    }
  },
  travel: {
    get title() {
      return 'Travel';
    }
  },
  other: {
    get title() {
      return 'Other';
    }
  }
});

export default {
  ticketPersonalLoanPurposes,
  TicketPersonalLoanPurpose
};
